module.exports = __webpack_public_path__ + "static/media/image_59.9ad30095.png";